// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// luismrosero1992@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyCMu5mFqWZKSXQNqs-2UbSLZj7mPp6itfw",
    authDomain: "syctiendadeportiva-59c9d.firebaseapp.com",
    projectId: "syctiendadeportiva-59c9d",
    storageBucket: "syctiendadeportiva-59c9d.firebasestorage.app",
    messagingSenderId: "1026534678182",
    appId: "1:1026534678182:web:9390d29c10282e97a0de67",
    measurementId: "G-EB9172YP39"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)